import useEditorDispatch from "./useEditorDispatch";
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import A from './ActionCreators';
import Tooltip from '@material-ui/core/Tooltip';
import { toggleStyleProperties } from './toolbarOrder';

export default function ToggleToolbarItem({
  item, 
  className, 
  selectedFigureItems, 
  unifiedGroup,
  figurePanelId
}){

  const dispatch = useDispatch();

  const editorDispatch = useEditorDispatch(); 

  let styleProperty = item.styleProperty;
  let valueToSet = item.valueToSet;
  let currentValue = (unifiedGroup?.style||{})[ styleProperty ];

  let selected = valueToSet === currentValue ? "selected" : "";

  if(item.valueToSet === 'bold'){ }

  let icon = useMemo(() => {
    if( item.hint && item.icon ){
      return <Tooltip title={item.hint}>{item.icon}</Tooltip>
    }else{
      return item.icon;
    }
  },[item])



  return (
    <div 
      menuItem={item.menuItem}
      onClick={e => {
        let value = (
              currentValue === valueToSet ? null : valueToSet
            )

        if( selectedFigureItems.expansionNodes ){
        editorDispatch({
          type:"propertyChange",
          properties:{
            [`style.${item.styleProperty}`]:value
          }
        })
        }else if( selectedFigureItems.cells ){

          dispatch(A.setCellsValue({

            figureItems:selectedFigureItems,
            figurePanelId,
            style:{
              [item.styleProperty]:value
            }

          }))
        }

        //toggleStyleProperties({dispatch,selectedFigureItems,item, figurePanelId})
      }}
      style={{
        padding:'4px',borderRadius:'5px'
      }}
      class={selected+" hoverable toolbar-button"}
    >
      {icon}
    </div>
  )
}
